import { render, staticRenderFns } from "./OfflineDetect.vue?vue&type=template&id=05f58c54&scoped=true"
import script from "./OfflineDetect.vue?vue&type=script&lang=js"
export * from "./OfflineDetect.vue?vue&type=script&lang=js"
import style0 from "./OfflineDetect.vue?vue&type=style&index=0&id=05f58c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f58c54",
  null
  
)

export default component.exports